import { render, staticRenderFns } from "./EducationSearchInput.vue?vue&type=template&id=67a3a9c9&scoped=true"
import script from "./EducationSearchInput.vue?vue&type=script&lang=js"
export * from "./EducationSearchInput.vue?vue&type=script&lang=js"
import style0 from "./EducationSearchInput.vue?vue&type=style&index=0&id=67a3a9c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3a9c9",
  null
  
)

export default component.exports